<div class="glass-card rounded-2xl mb-6 overflow-hidden">
  <div class="p-6 border-b border-white/10 flex items-center justify-between">
    <h2 class="text-lg font-semibold text-text-primary">Dokumente</h2>
    <!-- Every role. Buttons need type="button": the tabs sit inside the page's <form>. -->
    @if (saved()) {
      <button type="button" class="btn-primary flex items-center gap-2" [title]="'PDF, JPG, PNG oder SVG, max. ' + maxSizeLabel + ' pro Datei'" (click)="openUploadModal()">
        <span class="material-icons text-lg">upload_file</span>
        Dateien hochladen
      </button>
    }
  </div>

  @if (!saved()) {
    <div class="p-6">
      <p class="text-sm text-text-muted">Bitte erstellen Sie den Auftragsbegleitschein zuerst, um Dokumente hinzuzufügen.</p>
    </div>
  } @else {
    <div class="p-6 min-h-40 flex flex-col gap-4">
      <!-- Running / failed uploads -->
      @if (uploads().length > 0) {
        <ul class="flex flex-col gap-2">
          @for (upload of uploads(); track upload.key) {
            <li class="rounded-xl bg-white/5 border border-white/10 px-4 py-3">
              <div class="flex items-center justify-between gap-3">
                <span class="text-sm text-text-primary truncate min-w-0">{{ upload.name }}</span>
                @if (upload.error) {
                  <button
                    type="button"
                    class="p-1 rounded-lg flex text-text-muted hover:text-text-primary hover:bg-white/10 transition-all shrink-0"
                    title="Ausblenden"
                    (click)="dismissUpload(upload.key)"
                  >
                    <span class="material-icons text-lg">close</span>
                  </button>
                } @else if (upload.converting) {
                  <span class="text-xs text-text-muted shrink-0">Wird umgewandelt …</span>
                } @else {
                  <span class="text-xs text-text-muted shrink-0">{{ upload.progress }} %</span>
                }
              </div>
              @if (upload.error) {
                <p class="text-xs text-red-400 mt-1">{{ upload.error }}</p>
              } @else {
                <div class="mt-2 h-1.5 rounded-full bg-white/10 overflow-hidden" [class.animate-pulse]="upload.converting">
                  <div class="h-full bg-primary transition-all" [style.width.%]="upload.progress"></div>
                </div>
              }
            </li>
          }
        </ul>
      }

      <!-- Uploaded documents, newest first -->
      @if (rows().length === 0) {
        <p class="text-sm text-text-muted">
          @if (isLoading()) {
            Dokumente werden geladen …
          } @else {
            Noch keine Dokumente vorhanden. Über „Dateien hochladen“ PDFs oder Bilder hinzufügen (max. {{ maxSizeLabel }} pro Datei).
          }
        </p>
      } @else {
        <ul class="flex flex-col divide-y divide-white/10 rounded-xl border border-white/10 overflow-hidden">
          @for (row of rows(); track row.doc._id) {
            <li class="flex items-center gap-3 px-4 py-3 hover:bg-white/5 transition-colors">
              <span class="material-icons text-2xl text-red-400 shrink-0">picture_as_pdf</span>
              <button type="button" class="flex-1 min-w-0 text-left cursor-pointer group" title="Vorschau öffnen" (click)="openPreview(row.doc)">
                <span class="block text-sm font-medium text-text-primary truncate group-hover:text-primary-light">
                  {{ row.doc.originalName }}
                </span>
                <span class="block text-xs text-text-muted truncate">
                  {{ row.doc.uploadDate | date: 'dd.MM.yyyy HH:mm' }} · {{ row.doc.uploadedByName ?? '–' }}
                </span>
              </button>
              <!-- Owning Auftragsbegleitschein, once the order has several -->
              @if (showOwner()) {
                <span
                  class="hidden sm:inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium shrink-0 max-w-64"
                  [class]="row.isCurrentOwner ? 'bg-primary/15 text-primary-light' : 'bg-white/5 text-text-secondary'"
                  [title]="'Auftragsbegleitschein: ' + row.ownerLabel"
                >
                  <span class="material-icons text-sm">description</span>
                  <span class="truncate">{{ row.ownerLabel }}</span>
                </span>
              }
              @if (row.doc.exportDate) {
                <span
                  class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold bg-orange-400/15 text-orange-400 shrink-0"
                  title="Ins DMS exportiert"
                >
                  <span class="material-icons text-sm">lock</span>
                  DMS {{ row.doc.exportDate | date: 'dd.MM.yyyy' }}
                </span>
              }
              @if (row.canDelete) {
                <button
                  type="button"
                  class="p-2 cursor-pointer rounded-lg flex text-text-muted hover:text-red-400 hover:bg-red-400/10 transition-all shrink-0"
                  title="Dokument löschen"
                  (click)="confirmDelete(row.doc)"
                >
                  <span class="material-icons text-lg">delete</span>
                </button>
              }
            </li>
          }
        </ul>
      }
    </div>
  }
</div>
